module.exports = __webpack_public_path__ + "static/media/straighten_01.1f3f913e.png";